module.exports = __webpack_public_path__ + "media/images/shutterstock_1168325623-ed468d0930adbfecec83a5ec87dc61e7.jpg";